import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ServiceList from "./ServiceList";
import { getBusinessItemList } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  businessItemData: state.businessItemReducer.businessItemList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBusinessItemList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ServiceList);